export default __webpack_public_path__ + "img/main.connect-calendar.6c45852b.png";